"use client";

import { Header, MenuSection } from "react-aria-components";
import { Text } from "@zapier/design-system";
import styles from "./SearchDropdown.module.css";

interface SearchSectionProps {
  /** Stable id for the React Aria collection section. */
  id: string;
  title: string;
  children: React.ReactNode;
  displayHorizontal?: boolean;
}

/**
 * A React Aria `MenuSection` with a visible header. Children must be
 * `MenuItem`s (or a `Collection` of them) so React Aria can build the menu
 * collection and manage `aria-activedescendant` focus.
 */
export function SearchSection({
  id,
  title,
  children,
  displayHorizontal = false,
}: SearchSectionProps) {
  return (
    <MenuSection
      id={id}
      className={displayHorizontal ? styles.sectionHorizontal : styles.section}
    >
      <Header className={styles.sectionHeader}>
        <Text tag="h2" type="Body2" color="TextWeakest" margin="0 0 4px 0">
          {title}
        </Text>
      </Header>
      {children}
    </MenuSection>
  );
}
